/* eslint-disable */
export default {
  infoMessageMins: 'Salvar log automaticamente em {delayTime} minutos...',
  infoMessageMin: 'Salvar log automaticamente em {delayTime} minuto...',
  infoMessageSecs: 'Salvar log automaticamente em {delayTime} segundos...',
  infoMessageSec: 'Salvar log automaticamente em {delayTime} segundo...',
} as const;

// @key: @#@"infoMessageMins"@#@ @source: @#@"Auto-save log in {delayTime} minutes..."@#@
// @key: @#@"infoMessageMin"@#@ @source: @#@"Auto-save log in {delayTime} minute..."@#@
// @key: @#@"infoMessageSecs"@#@ @source: @#@"Auto-save log in {delayTime} seconds..."@#@
// @key: @#@"infoMessageSec"@#@ @source: @#@"Auto-save log in {delayTime} second..."@#@
